import useTranslation from 'next-translate/useTranslation';

// Third-party
import { useAtomValue } from 'jotai';

// Constants

// Components
import { EmptyState } from '@/components/base/EmptyState';
import {
    SocialInboxConversationContent,
    SocialInboxConversationHeader
} from '@/components/pages/conversations/SocialInbox';
import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

interface SocialInboxChatViewProps {
    className?: string;
}

export const SocialInboxChatView = ({ className }: SocialInboxChatViewProps) => {
    const { t } = useTranslation('conversations');

    const openedMessage = useAtomValue(openedMessageAtom);

    return (
        <div
            data-testid="social-inbox-chat-view"
            className={`h-full bg-white dark:bg-icoDarkMode-deepBlack ${className}`}>
            {openedMessage ? (
                <div className="flex h-full flex-col">
                    <SocialInboxConversationHeader />
                    <SocialInboxConversationContent />
                </div>
            ) : (
                <EmptyState
                    icon="bubbles-outline"
                    title={t('social_inbox.no_conversation_title')}
                    description={t('social_inbox.no_conversation_description')}
                    className="h-full"
                />
            )}
        </div>
    );
};
